import _ from 'lodash'

/**
 * Validate
 * @param v
 * @returns {boolean}
 */
export function isEmpty(v) {
  const falsyValues = ['0', '1111', '00']
  if (_.isArray(v) || _.isObject(v)) {
    return _.isEmpty(v)
  } else {
    return _.isNil(v) || _.trim(v) === '' || v === 0 || falsyValues.includes(v)
  }
}

export function getFullAddress(address) {
  const { address_lines, postal_code } = address

  const nonEmptyLines = address_lines.map((lineObj) => Object.values(lineObj).join('')).filter((line) => !isEmpty(line))

  const fullAddress = [...nonEmptyLines, postal_code].filter(Boolean)

  return fullAddress.join(', ')
}

export const parseFilters = (filters) => {
  const queryParams = {}
  for (const filterKey in filters) {
    const { filterType, filter, values, value } = filters[filterKey]
    queryParams[filterKey] = filterType === 'text' ? filter : filterType === 'set' ? values : value
  }
  return queryParams
}

export const getBranchIdFromUrl = (url) => {
  const regex = /locationIdentifier=BRANCH%5E(\d+)/
  const matches = url.match(regex)

  return matches?.[1] || null
}

export const getAvaliableQuoteGiverCodes = ref(['270', '299'])
